"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

var _filterTab = _interopRequireDefault(require("./filter-tab"));

var _filterTabContainer = _interopRequireDefault(require("./filter-tab-container"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FilterFlyOutButton = function FilterFlyOutButton(_ref) {
  var children = _ref.children,
      useOutsideClick = _ref.useOutsideClick,
      badgeCount = _ref.badgeCount,
      onTabChange = _ref.onTabChange,
      onReset = _ref.onReset;
  var intl = (0, _nicbaseTranslation.useIntl)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showDialog = _useState2[0],
      setShowDialog = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      currentTop = _useState4[0],
      setCurrentTop = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      currentLeft = _useState6[0],
      setCurrentLeft = _useState6[1];

  var buttonRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (showDialog) {
      // determine position where the dialog in portal will be placed
      var _buttonRef$current$ge = buttonRef.current.getBoundingClientRect(),
          top = _buttonRef$current$ge.top,
          left = _buttonRef$current$ge.left;

      var _window = window,
          scrollX = _window.scrollX,
          scrollY = _window.scrollY;
      var newTop = top + scrollY;
      var newLeft = left + scrollX;

      if (currentTop !== newTop) {
        setCurrentTop(newTop);
      }

      if (currentLeft !== newLeft) {
        setCurrentLeft(newLeft);
      }
    }
  }, [currentLeft, currentTop, showDialog]);

  var handleClose = function handleClose() {
    setShowDialog(false);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, showDialog && /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement(_filterTabContainer["default"], {
    style: {
      top: currentTop,
      left: currentLeft
    },
    className: "absolute z-20 origin-top-left",
    onClose: handleClose,
    onReset: onReset,
    onTabChange: onTabChange,
    useOutsideClick: useOutsideClick
  }, children), document.body), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    ref: buttonRef,
    tabIndex: 0,
    className: "relative inline-block focus:outline-none p-2 shadow border rounded",
    title: intl.formatMessage({
      id: 'filters.openDialog'
    }),
    "aria-label": intl.formatMessage({
      id: 'filters.openDialog'
    }),
    onClick: function onClick() {
      setShowDialog(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Funnel, null), Number.isInteger(badgeCount) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute flex justify-center items-center h-5 w-5 -bottom-2 -right-2 z-1 bg-primary text-white text-sm rounded-full",
    title: intl.formatMessage({
      id: 'filter.badgeCount'
    })
  }, badgeCount)));
};

FilterFlyOutButton.defaultProps = {
  children: null,
  useOutsideClick: true,
  badgeCount: null,
  onTabChange: function onTabChange() {},
  onReset: function onReset() {}
};
FilterFlyOutButton.Tab = _filterTab["default"];
var _default = FilterFlyOutButton;
exports["default"] = _default;